import { TransferenciaGetModel } from "model/api/gestao/transferencia/transferencia-get-model";
import { DefaultFormProps } from "../../utils";
import { TransferenciaFormRef } from "views/components/dialog/dialog-transferência/dialog-transferencia";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFormTransferenciaValidation } from "./form-transferencia-validation";
import { isEmpty, isEqual } from "lodash";
import { toDateString } from "utils/to-date";
import { CircularLoading } from "views/components/utils";
import { Button, Grid } from "@material-ui/core";
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { makeUtilClasses } from "views/theme";
import { useStyles } from "./form-transferencia-styles";
import { toDecimal } from "utils/to-decimal";
import { SelectSaurus } from "views/components/controles/selects/select-saurus/select-saurus";
import { TpPagamentoMock } from "data/mocks/tipo-pagamento-mock";
import { EnumTpPagamento } from "model/enums/enum-tp-pagamento";
import { useConsultaCnpj } from "data/api/wsmaster";
import { stringNumeros } from "utils/string-numeros";
import { useShowAviso } from "services/app/hooks/show-aviso";
import { useGetContaBancariaConfiguracao } from "data/api/gestao/conta-bancaria-configuracao/get-conta-bancaria-configuracao";
import { ContaBancariaListModel } from "model/api/gestao/conta-bancaria/conta-bancaria-list-model";
import { useSessaoAtual, useToastSaurus } from "services/app";
import { DialogContaBancariaList } from "views/components/dialog/dialog-conta-bancaria-list/dialog-conta-bancaria-list";
import { AutocompleteBancos } from "views/components/controles/autocompletes/autocomplete-bancos/autocomplete-bancos";
import { useGetContaBancariaById } from "data/api/gestao/conta-bancaria/get-conta-bancaria-by-id";
import { guidEmpty } from "utils/guid-empty";
import { ContaBancariaConfiguracaoModel } from "model/api/gestao/conta-bancaria-configuracao/conta-bancaria-configuracao-model";

interface TransferenciaFormProps extends DefaultFormProps<TransferenciaGetModel> {
    preencherConfigAuto?: boolean;
    transferencia?: TransferenciaGetModel
}

export const FormTransferencia = React.forwardRef<
    TransferenciaFormRef,
    TransferenciaFormProps
>(({ preencherConfigAuto = false, transferencia, ...props }: TransferenciaFormProps, refs) => {

    const [accordion, setAccordion] = useState({
        transferencia: false,
        recebedor: false,
        pagador: true
    })

    const { showAviso } = useShowAviso();

    const { FormTransferenciaValidationYup, accordionMockValidation } = useFormTransferenciaValidation();

    const utilClasses = makeUtilClasses();

    const classes = useStyles()
    const { consultarCNPJ } = useConsultaCnpj();

    const [dialogContas, setDialogContas] = useState<boolean>(false)
    const { getContaBancariaConfiguracao } = useGetContaBancariaConfiguracao();
    const { getContaBancariaById } = useGetContaBancariaById();
    const [, setLoadingConfig] = useState<boolean>(false);
    const [, setRender] = useState<boolean>(false)
    const mostrarMensagemImport = useRef<boolean>(preencherConfigAuto ? false : true);
    const { showToast } = useToastSaurus()

    const { getEmpresa } = useSessaoAtual();

    const razaoSocial = getEmpresa().Descricao;

    const noEdit = transferencia?.id ? true : false;

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue,
        trigger,
    } = useForm<TransferenciaGetModel>({
        defaultValues: { ...new TransferenciaGetModel() },
        criteriaMode: 'all',
        mode: 'onChange',
        resolver: yupResolver(FormTransferenciaValidationYup),
    })

    const errorsRef = useRef(errors);
    errorsRef.current = errors;

    const getDadosContaBancaria = useCallback(async () => {
        try {
            const result = await getContaBancariaById(transferencia?.contaBancariaId || '');
            if (result.erro) throw result.erro;

            const contaBancaria = result.resultado?.data;

            setValue('bancoPagador', `${contaBancaria?.banco.toString()} - ${contaBancaria?.nomeBanco}`);
        } catch (err: any) {
            console.log('')
        }
    }, [getContaBancariaById, setValue, transferencia?.contaBancariaId])

    const onSubmit = (form: TransferenciaGetModel) => {
        form.tipoPagamento = !isEmpty(form.tipoPagamento) ? form.tipoPagamento : ''

        form.valorAutorizado = toDecimal(form.valorAutorizado)

        form.valorPagamento = toDecimal(form.valorPagamento)

        form.bancoDestino = !isEmpty(form.bancoDestino) ? form.bancoDestino : ''

        form.codigoFornecedor = !isEmpty(form.codigoFornecedor) ? form.codigoFornecedor : ''

        form.configContaBancariaId = !isEmpty(form.configContaBancariaId) ? form.configContaBancariaId : ''

        form.contaBancariaId = !isEmpty(form.contaBancariaId) ? form.contaBancariaId : ''

        form.dataPagamento = !isEmpty(form.dataPagamento) ? form.dataPagamento : ''

        form.digitoAgenciaDestino = !isEmpty(form.digitoAgenciaDestino) ? form.digitoAgenciaDestino : ''

        form.externalCode = !isEmpty(form.externalCode) ? form.externalCode : ''

        form.externalId = !isEmpty(form.externalId) ? form.externalId : ''

        form.bancoPagador = !isEmpty(form.bancoPagador) ? form.bancoPagador : ''

        form.externalCode = !isEmpty(form.externalCode) ? form.externalCode : ''

        form.externalId = !isEmpty(form.externalId) ? form.externalId : ''

        form.agenciaDestino = !isEmpty(form.agenciaDestino) ? form.agenciaDestino : ''

        form.digitoAgenciaDestino = !isEmpty(form.digitoAgenciaDestino) ? form.digitoAgenciaDestino : ''

        form.nomeAgenciaDestino = !isEmpty(form.nomeAgenciaDestino) ? form.nomeAgenciaDestino : ''

        form.contaCorrenteDestino = !isEmpty(form.contaCorrenteDestino) ? form.contaCorrenteDestino : ''

        form.valorAutorizado = toDecimal(form.valorAutorizado)

        form.id = !isEmpty(form.id) ? form.id : ''
        props.onSubmit(form);
    };

    const onSelectConta = useCallback(async (model: ContaBancariaListModel, showError: boolean = true) => {
        try {
            const res = await getContaBancariaConfiguracao(model.id)
            setLoadingConfig(false);

            if (res.erro) throw res.erro;

            if (isEmpty(res.resultado?.data.list)) {
                throw new Error(showError ? 'Não foram encontradas configurações nesta conta.' : '');
            }
            const configModel = res.resultado!.data.list[0]

            setValue('contaBancariaId', model.id)
            setValue('configContaBancariaId', configModel.id)
            setValue('razaoSocial', razaoSocial)
            setValue('codigoAgencia', model.agencia.toString() + model.digitoAgencia)
            setValue('bancoPagador', `${model.banco.toString()} - ${model.nomeBanco}`)
            setValue('numeroInscricao', model.documentoTitular)
            setValue('numeroConta', model.conta.toString() + '' + model.digitoConta)
            setValue('codigoAgencia', model.agencia + '' + model.digitoAgencia)

            setDialogContas(false)
            setRender(prev => !prev)

            if (mostrarMensagemImport.current) {
                showToast('success', 'Informações importadas com sucesso.')
            }

            mostrarMensagemImport.current = true;

            if (!isEmpty(errorsRef.current)) {
                trigger();
            }


        } catch (e: any) {
            showAviso('error', e.message)
        }
    }, [getContaBancariaConfiguracao, razaoSocial, setValue, showAviso, showToast, trigger])

    useEffect(() => {
        if (transferencia?.id && transferencia?.id !== guidEmpty()) {
            getDadosContaBancaria()
        }
    }, [getDadosContaBancaria, transferencia?.id])


    React.useImperativeHandle(refs, () => ({
        submitForm: () => {
            handleSubmit(onSubmit, (errors) => {
                const arr = Object.keys(errors);

                setAccordion(() => {
                    const accordions = {
                        transferencia: false,
                        pagador: false,
                        recebedor: false
                    }
                    arr.forEach(item => {
                        const match = accordionMockValidation.find(m => m.campo === item);
                        if (match) {
                            const key = match.accordion as keyof typeof accordions;
                            accordions[key] = true;
                        }
                    })

                    return accordions;
                })
            })();
        },
        resetForm: () => {
            reset();
        },
        fillForm: (model: TransferenciaGetModel) => {
            if (!isEqual(model, new TransferenciaGetModel())) {
                model.dataPagamento = !isEmpty(model.dataPagamento) ? (toDateString(model.dataPagamento, 'YYYY-MM-DD') || '') : ''


            } else {
                model.dataPagamento = toDateString(new Date(), 'YYYY-MM-DD') || '';
            }
            model.razaoSocial = razaoSocial;
            reset({ ...model });
        },
        carregarDadosContaBancaria: (model: ContaBancariaConfiguracaoModel) => {
            //
        }
    }));

    return (
        <>
            {(props.loading && props.showLoading) ? (
                <CircularLoading tipo="FULLSIZED" />
            ) : null}
            <div className={utilClasses.formContainer}>
                <form
                    onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <AccordionSaurus
                                labelPrimary='Dados do Pagador'
                                expanded={accordion.pagador}
                                onChange={() => setAccordion(prev => ({
                                    ...prev,
                                    pagador: !prev.pagador
                                }))}
                            >
                                <Grid container spacing={2}>
                                    {!transferencia?.id && (
                                        <Grid item xs={12}>
                                            <Button
                                                variant='outlined'
                                                color='primary'
                                                fullWidth
                                                size='small'
                                                onClick={() => setDialogContas(true)}
                                            >
                                                Importar Dados a partir de Conta Cadastrada
                                            </Button>
                                        </Grid>
                                    )}

                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            name="numeroInscricao"
                                            control={control}
                                            render={({ field }) => (
                                                <TextFieldSaurus
                                                    tipo={'CNPJ_CPF'}
                                                    fullWidth
                                                    variant="outlined"
                                                    label="CNPJ/CPF"
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    autoComplete="off"
                                                    error={Boolean(
                                                        errors.numeroInscricao
                                                    )}
                                                    helperText={
                                                        errors?.numeroInscricao
                                                            ? errors?.numeroInscricao?.message
                                                            : undefined
                                                    }
                                                    disabled={props.loading}
                                                    {...field}
                                                    onChange={(e) => setValue('numeroInscricao', stringNumeros(e.target.value))}
                                                    readOnly
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={8}>
                                        <Controller
                                            control={control}
                                            name='razaoSocial'
                                            render={({ field }) => (
                                                <TextFieldSaurus
                                                    label='Razão Social'
                                                    fullWidth
                                                    disabled={props.loading}
                                                    {...field}
                                                    error={!isEmpty(errors.razaoSocial)}
                                                    helperText={!isEmpty(errors.razaoSocial) && !isEmpty(errors.razaoSocial.message) ?
                                                        errors.razaoSocial.message : undefined}
                                                    readOnly
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            control={control}
                                            name='bancoPagador'
                                            render={({ field }) => (
                                                <TextFieldSaurus
                                                    label='Banco'
                                                    fullWidth
                                                    disabled={props.loading}
                                                    {...field}
                                                    error={!isEmpty(errors.bancoPagador)}
                                                    helperText={!isEmpty(errors.bancoPagador) && !isEmpty(errors.bancoPagador.message) ?
                                                        errors.bancoPagador.message : undefined}
                                                    readOnly={noEdit}
                                                    value={field.value || ''}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            control={control}
                                            name='codigoAgencia'
                                            render={({ field }) => (
                                                <TextFieldSaurus
                                                    label='Agência (C/DIG)'
                                                    fullWidth
                                                    tipo="NUMERO"
                                                    disabled={props.loading}
                                                    {...field}
                                                    error={!isEmpty(errors.codigoAgencia)}
                                                    helperText={!isEmpty(errors.codigoAgencia) && !isEmpty(errors.codigoAgencia.message) ?
                                                        errors.codigoAgencia.message : undefined}
                                                    readOnly={noEdit}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            control={control}
                                            name='numeroConta'
                                            render={({ field }) => (
                                                <TextFieldSaurus
                                                    label='Conta (C/DIG)'
                                                    tipo='NUMERO'
                                                    fullWidth
                                                    disabled={props.loading}
                                                    {...field}
                                                    error={!isEmpty(errors.numeroConta)}
                                                    helperText={!isEmpty(errors.numeroConta) && !isEmpty(errors.numeroConta.message) ?
                                                        errors.numeroConta.message : undefined}
                                                    readOnly={noEdit}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionSaurus>
                        </Grid>
                        <Grid item xs={12}>
                            <AccordionSaurus
                                labelPrimary='Dados do Recebedor'
                                expanded={accordion.recebedor}
                                onChange={() => setAccordion(prev => ({
                                    ...prev,
                                    recebedor: !prev.recebedor
                                }))}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} className={classes.inputText}>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    control={control}
                                                    name='codigoFornecedor'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            tipo={'CNPJ_CPF'}
                                                            fullWidth
                                                            searchable={transferencia?.id ? false : true}
                                                            readOnly={noEdit}
                                                            onSearch={async (value) => {
                                                                try {
                                                                    if (value.length > 11) {
                                                                        let res = await consultarCNPJ(value)

                                                                        setValue('codigoFornecedor', res.razaoSocial)
                                                                        trigger();
                                                                    } else {
                                                                        showAviso('info', 'Busca disponível apenas para CNPJ');
                                                                        return
                                                                    }
                                                                }
                                                                catch (erro: any) {
                                                                    return showAviso('error', erro.message)
                                                                }
                                                            }}
                                                            variant="outlined"
                                                            label="CNPJ/CPF"
                                                            InputLabelProps={{
                                                                shrink: true
                                                            }}
                                                            autoComplete="off"
                                                            error={Boolean(
                                                                errors.codigoFornecedor && errors.codigoFornecedor.message
                                                            )}
                                                            helperText={
                                                                errors?.codigoFornecedor
                                                                    ? errors?.codigoFornecedor?.message
                                                                    : undefined
                                                            }
                                                            {...field}
                                                            onChange={(e) => setValue('codigoFornecedor', stringNumeros(e.target.value))}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    control={control}
                                                    name='nomeFornecedor'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Nome'
                                                            tipo='TEXTO'
                                                            disabled={props.loading}
                                                            readOnly={noEdit}
                                                            {...field}
                                                            error={!isEmpty(errors.nomeFornecedor)}
                                                            helperText={!isEmpty(errors.nomeFornecedor) && !isEmpty(errors.nomeFornecedor.message) ?
                                                                errors.nomeFornecedor.message : undefined}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    control={control}
                                                    name='bancoDestino'
                                                    render={({ field }) => (
                                                        <AutocompleteBancos
                                                            label="Banco"
                                                            placeholder="Digite um banco"
                                                            disabled={props.loading || noEdit}
                                                            error={!isEmpty(errors.bancoDestino)}
                                                            helperText={!isEmpty(errors.bancoDestino) && !isEmpty(errors.bancoDestino.message) ?
                                                                errors.bancoDestino.message : undefined}
                                                            onChange={(e) => setValue('bancoDestino', e.value.codigo)}
                                                            value={field.value}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <Controller
                                                    control={control}
                                                    name='agenciaDestino'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Agência'
                                                            tipo='TEXTO'
                                                            disabled={props.loading}
                                                            readOnly={noEdit}
                                                            {...field}
                                                            error={!isEmpty(errors.agenciaDestino)}
                                                            helperText={!isEmpty(errors.agenciaDestino) && !isEmpty(errors.agenciaDestino.message) ?
                                                                errors.agenciaDestino.message : undefined}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item md={2}>
                                                <Controller
                                                    control={control}
                                                    name='digitoAgenciaDestino'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Dig. Agência'
                                                            tipo='TEXTO'
                                                            disabled={props.loading}
                                                            readOnly={noEdit}
                                                            {...field}
                                                            error={!isEmpty(errors.digitoAgenciaDestino)}
                                                            helperText={!isEmpty(errors.digitoAgenciaDestino) && !isEmpty(errors.digitoAgenciaDestino.message) ?
                                                                errors.digitoAgenciaDestino.message : undefined}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <Controller
                                                    control={control}
                                                    name='contaCorrenteDestino'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Conta (C/DIG)'
                                                            tipo='NUMERO'
                                                            disabled={props.loading}
                                                            readOnly={noEdit}
                                                            {...field}
                                                            error={!isEmpty(errors.contaCorrenteDestino)}
                                                            helperText={!isEmpty(errors.contaCorrenteDestino) && !isEmpty(errors.contaCorrenteDestino.message) ?
                                                                errors.contaCorrenteDestino.message : undefined}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <Controller
                                                    control={control}
                                                    name='nomeAgenciaDestino'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Nome AG'
                                                            tipo='TEXTO'
                                                            disabled={props.loading}
                                                            readOnly={noEdit}
                                                            {...field}
                                                            error={!isEmpty(errors.nomeAgenciaDestino)}
                                                            helperText={!isEmpty(errors.nomeAgenciaDestino) && !isEmpty(errors.nomeAgenciaDestino.message) ?
                                                                errors.nomeAgenciaDestino.message : undefined}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AccordionSaurus>
                        </Grid>
                        <Grid item xs={12}>
                            <AccordionSaurus
                                labelPrimary='Dados da Transferência'
                                expanded={accordion.transferencia}
                                onChange={() => setAccordion(prev => ({
                                    ...prev,
                                    transferencia: !prev.transferencia
                                }))}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} className={classes.inputText}>
                                            <Grid item xs={12} md={3}>
                                                <Controller
                                                    control={control}
                                                    name='tipoPagamento'
                                                    render={({ field }) => (
                                                        <SelectSaurus
                                                            label='Tipo Pagamento'
                                                            conteudo={TpPagamentoMock}
                                                            fullWidth
                                                            disabled={props.loading || noEdit}
                                                            {...field}
                                                            error={!isEmpty(errors.tipoPagamento)}
                                                            helperText={!isEmpty(errors.tipoPagamento) && !isEmpty(errors.tipoPagamento.message) ?
                                                                errors.tipoPagamento.message : undefined}
                                                            onChange={(e: any) => {
                                                                const newValue = e.target.value as EnumTpPagamento;
                                                                setValue('tipoPagamento', newValue);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <Controller
                                                    control={control}
                                                    name='dataPagamento'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Data'
                                                            tipo='DATA'
                                                            disabled={props.loading}
                                                            {...field}
                                                            error={!isEmpty(errors.dataPagamento)}
                                                            helperText={!isEmpty(errors.dataPagamento) && !isEmpty(errors.dataPagamento.message) ?
                                                                errors.dataPagamento.message : undefined}
                                                            readOnly={noEdit}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <Controller
                                                    control={control}
                                                    name='valorPagamento'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Valor'
                                                            tipo='DECIMAL'
                                                            showStartAdornment
                                                            manterMascara
                                                            fullWidth
                                                            disabled={props.loading}
                                                            {...field}
                                                            error={!isEmpty(errors.valorPagamento)}
                                                            helperText={!isEmpty(errors.valorPagamento) && !isEmpty(errors.valorPagamento.message) ?
                                                                errors.valorPagamento.message : undefined}
                                                            readOnly={noEdit}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <Controller
                                                    control={control}
                                                    name='valorAutorizado'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Valor Autorizado'
                                                            tipo='DECIMAL'
                                                            showStartAdornment
                                                            manterMascara
                                                            fullWidth
                                                            disabled={props.loading}
                                                            {...field}
                                                            error={!isEmpty(errors.valorAutorizado)}
                                                            helperText={!isEmpty(errors.valorAutorizado) && !isEmpty(errors.valorAutorizado.message) ?
                                                                errors.valorAutorizado.message : undefined}
                                                            readOnly={noEdit}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} >
                                                <Controller
                                                    name='numeroCompromissoBanco'
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Nro Compromisso Banco'
                                                            {...field}
                                                            error={Boolean(errors.numeroCompromissoBanco)}
                                                            helperText={Boolean(errors.numeroCompromissoBanco && errors.numeroCompromissoBanco.message) ?
                                                                errors.numeroCompromissoBanco?.message : undefined}
                                                            readOnly
                                                            value={(() => {
                                                                return !field.value ? 'A GERAR' : field.value
                                                            })()}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} >
                                                <Controller
                                                    name='numeroCompromissoCliente'
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Nro Compromisso Cliente'
                                                            {...field}
                                                            error={Boolean(errors.numeroCompromissoCliente)}
                                                            helperText={Boolean(errors.numeroCompromissoCliente && errors.numeroCompromissoCliente.message) ?
                                                                errors.numeroCompromissoCliente?.message : undefined}
                                                            readOnly
                                                            value={(() => {
                                                                return !field.value ? 'A GERAR' : field.value
                                                            })()}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name='usoEmpresa'
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='Uso Empresa'
                                                            {...field}
                                                            error={Boolean(errors.usoEmpresa)}
                                                            helperText={Boolean(errors.usoEmpresa && errors.usoEmpresa.message) ?
                                                                errors.usoEmpresa?.message : undefined}
                                                            readOnly={noEdit}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} >
                                                <Controller
                                                    name='externalId'
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='External Id'
                                                            {...field}
                                                            error={Boolean(errors.externalId)}
                                                            helperText={Boolean(errors.externalId && errors.externalId.message) ?
                                                                errors.externalId?.message : undefined}
                                                            readOnly={noEdit}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    control={control}
                                                    name='externalCode'
                                                    render={({ field }) => (
                                                        <TextFieldSaurus
                                                            label='External Code'
                                                            tipo='TEXTO'
                                                            disabled={props.loading}
                                                            {...field}
                                                            error={!isEmpty(errors.externalCode)}
                                                            helperText={!isEmpty(errors.externalCode) && !isEmpty(errors.externalCode.message) ?
                                                                errors.externalCode.message : undefined}
                                                            readOnly={noEdit}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </AccordionSaurus>
                        </Grid>
                    </Grid>
                    <DialogContaBancariaList
                        aberto={dialogContas}
                        handleClose={() => setDialogContas(false)}
                        onClick={onSelectConta}
                        preencherAutomaticamente={preencherConfigAuto}
                        setLoading={setLoadingConfig}
                    />
                    <Button style={{ display: 'none' }} type="submit"></Button>
                </form >
            </div >
        </>
    );
})